export const IDLE = 'idle'
export const FETCHING = 'fetching'
export const SUBMITTING = 'submitting'
export const LOADING = 'loading'
export const ERROR = 'error'
